import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router keeps the window scroll position across client-side navigations,
 * so moving from a scrolled page to a new one lands you mid-page. A hard
 * refresh looked fine only because the browser reloads at the top.
 *
 * Mounted once inside the router, this resets the scroll on every path change.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
